import { Component } from '@builder.io/sdk';

import { ButtonProps } from '@videoblocks/design-system';

import { BUTTON_VARIANTS, REL_VALUES } from '../utils/constants';

export type CategoryPillsButtons = ButtonProps & {
    text: string;
    href?: string;
};

export const config: Component = {
    name: 'Category Pills',
    inputs: [
        {
            name: 'heading',
            type: 'string',
            required: false,
            defaultValue: 'Top stock footage categories',
        },
        {
            name: 'pills',
            type: 'list',
            required: true,
            defaultValue: [{ href: '/', label: 'Category Pill', image: '' }],
            subFields: [
                {
                    name: 'label',
                    type: 'string',
                    required: true,
                    defaultValue: 'Pill',
                },
                {
                    name: 'image',
                    type: 'file',
                    allowedFileTypes: ['jpg', 'jpeg', 'png', 'webp'],
                    required: true,
                    defaultValue: '',
                },
                {
                    name: 'href',
                    type: 'string',
                    required: true,
                    defaultValue: '/',
                },
            ],
        },
        {
            name: 'showCallToAction',
            type: 'boolean',
            defaultValue: true,
        },
        {
            name: 'callToAction',
            type: 'object',
            defaultValue: {
                text: 'Browse All Categories',
                href: '/',
                variant: BUTTON_VARIANTS[1],
                size: 'large',
                target: '_self',
                rel: '',
            },
            showIf: (options) => options.get('showCallToAction') as boolean,
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    required: true,
                },
                {
                    name: 'href',
                    type: 'string',
                    required: true,
                },
                {
                    name: 'target',
                    type: 'string',
                    enum: ['_self', '_blank', '_parent', '_top'],
                    helperText:
                        'For explanation of options, see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target',
                },
                {
                    name: 'rel',
                    type: 'string',
                    enum: REL_VALUES,
                    helperText:
                        'For documentation on accepted values, see https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types for link types allowed in <a> elements',
                },
                {
                    name: 'variant',
                    type: 'string',
                    enum: BUTTON_VARIANTS,
                },
                {
                    name: 'size',
                    type: 'string',
                    enum: ['default', 'large'],
                },
                {
                    name: 'disabled',
                    type: 'boolean',
                    defaultValue: false,
                    enum: [
                        {
                            label: 'Enabled',
                            value: false,
                        },
                        {
                            label: 'Disabled',
                            value: true,
                        },
                    ],
                },
            ],
        },
    ],
};
